export const isSentryEnabledEnv = (environment = '') =>
  !['dev', 'development', 'local-cosmos', 'localdev'].includes(environment);
